
<template>
    <div>
        <div class="setup-form p-5">
            <h1 class="complete-account-setup-heading">Create your loyalty program</h1>
            <p class="complete-account-setup-description">Complete your terms and conditions and privacy policy so your customers are fully aware about your company’s loyalty program.</p>
            <b-row class="mt-5">
                <b-col sm="12" md="2"
                    :class="{'col-md-3 text-left': isSetup}">
                    <h6 class="align-middle mb-1">Terms &amp; Conditions</h6>
                    <span class="label-helper">Input your terms and conditions so your customer knows about the full mechanics and benefits of your loyalty program.</span>
                </b-col>
                <b-col>
                    <b-form-group
                        id="terms-and-conditions-fieldset"
                        :invalid-feedback="errorMessage('terms_condition')"
                                    :state="isValid('terms_condition')"
                    >
                        <b-textarea id="terms-and-conditions" placeholder="Terms &amp; Conditions" max-rows="10" v-model="stepThreeForm.terms_condition"></b-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <hr>
            <b-row class="mt-5">
                <b-col sm="12" md="2" :class="{'col-md-3 text-left': isSetup}">
                    <h6 class="align-middle mb-1">Privacy Policy</h6>
                    <span class="label-helper">Input your privacy policy so your customers know that their information is safe.</span>
                </b-col>
                <b-col>
                    <b-form-group
                        id="privacy-policy-fieldset"
                        :invalid-feedback="errorMessage('privacy_policy')"
                        :state="isValid('privacy_policy')"
                    >
                        <b-textarea id="privacy-policy" placeholder="Privacy Policy" max-rows="10" v-model="stepThreeForm.privacyPolicy"></b-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
        </div>
        <div class="button-wrapper px-5 py-3" v-bind:class="{ 'retain-height': subIsActive('/setup/start') }">
            <b-button variant="outline-secondary" v-show="!subIsActive('/setup/start')" :to="'/setup/step-2'">
                Back
            </b-button>
            <b-button variant="primary" class="float-right" @click="sendForm">
                <span v-if="loading">Submitting...</span>
                <span v-else>Finish Setup</span>
            </b-button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: 'step-3',
    data() {
        return {
            isSetup: true
        }
    },
    computed: {
        ...mapState('setup', 
            [
                'stepThreeForm',
                'nextStep',
                'errors',
                'loading'
            ])
    },
    methods: {
        subIsActive(input) {
            const paths = Array.isArray(input) ? input : [input];
            return paths.some(path => {
                return this.$route.path.indexOf(path) === 0; // current path starts with this path string
            });
        },
        async sendForm() {
            this.$store.dispatch("setup/resetErrors");
            this.$store.dispatch("setup/saveStepThree", this.stepThreeForm);
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }
            return this.errors.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors.errors[field] ? false : true;
        },
    }
};
</script>
<style lang="scss">
</style>